module.exports = __webpack_public_path__ + "static/img/home_h122px_web_icon_nor@2x.79abb5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_web_icon_nor@2x.png
// module id = kGT9
// module chunks = 0